<template>
  <router-view />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class PayoutLists extends Vue {}
</script>

<style scoped lang="scss"></style>
